import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Dropdown from 'react-dropdown';

const AudioInputOptions = ({track}) => { 
    let [options, setOptions] = useState([]);
    let [selectedChannel, setSelectedChannel] = useState(undefined);
    let audioInputManager = track.audioInputManager;
    useEffect(() => {
        let options = [
            {value: 'none', label:'None'},
        ];
        
        if (track.audioInputManager !== undefined) {
            track.audioInputManager.getInputChannels().forEach(
                channel => options.push({value: channel, label: channel}));
        }
        setOptions(options);
    }, [track]);

    const onSelectChannel = useCallback((o) => {
        let value = o.value === 'none' ? undefined : o.value;
        track.setAudioInput(value);
        setSelectedChannel(value);
    }, [track, setSelectedChannel]);

    const getChannelOption = useCallback((val) => {
        for (var i=0; i < options.length; i++) {
            if (options[i].value == val) {
                return options[i];
            }
        }
        return undefined;
    }, [options]);

    return (
        <div className="audio-input-dropdown-container">
          <Dropdown
            className='audio-input-dropdown'
            controlClassName='audio-input-control-dropdown'
            arrowClassName='audio-input-arrow-dropdown'
            options={options}
            onChange={onSelectChannel}
            value={getChannelOption(track.audioInputChannel)}
            placeholder="Input" />
        </div>
        );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AudioInputOptions);
